import React, {Fragment, useEffect} from "react";
import { Outlet, Link } from "react-router-dom";
import { getAction, isAdmin } from "../util/helper";
// redux
import { useSelector, useDispatch } from 'react-redux';
import codeReducer from "../redux/reducers/codeReducer";
import { setCodes } from "../redux/actions/codeAction";
import codeGroupReducer from "../redux/reducers/codeGroupReducer";
import { setCodeGroups } from "../redux/actions/codeGroupAction";
import WebService from "../util/webService";
import { Navigate } from "react-router-dom";
import { setSchools } from '../redux/actions/schoolAction';
import { useNavigate } from "react-router-dom";

const fetchSchools = async() => {

}
const onLoad = async dispatch => {
  console.log('RootPage onLoad...')
}

const RootPage = () => {
  // redux
  const dispatch = useDispatch()
  const account = useSelector(state => state.accountReducer)
  const navigate = useNavigate()

  useEffect(() => {
    onLoad(dispatch)
    if (account.hasOwnProperty('user')) {
      console.log('account=>', account)
      if (isAdmin(account)) {
        // navigate('/admin/dashboard')
        navigate('/user/wallet')
      }
      else {
        navigate('/user/wallet')
      }

    }
    else {
      navigate('/login')
    }
  }, [])

  return (
    <Fragment></Fragment>
  )
};

export default RootPage;
